import { FormControlLabel, Grid, Radio, RadioGroup } from '@mui/material';
import React, { FC, useEffect, useState } from 'react';
import { QuestionView } from '@views';
import { useNavigationEligibility } from '@components/SurveyDrawer/NavigationEligibilityContextProvider';

interface MutuallyExclusiveResponseProps {
  currentQuestion: QuestionView;
}

export const MutuallyExclusiveResponse: FC<MutuallyExclusiveResponseProps> = ({ currentQuestion }) => {
  const { triggerEligibility } = useNavigationEligibility();

  // Initialize selected state from currentQuestion
  const initialSelectedId = currentQuestion.responses.find((r) => r.selected)?.id ?? -1;
  const [selected, setSelected] = useState<number>(initialSelectedId);

  useEffect(() => {
    // Update local state if question changes (e.g. user navigates next/previous)
    const newSelected = currentQuestion.responses.find((r) => r.selected)?.id ?? -1;
    setSelected(newSelected);
  }, [currentQuestion]);

  const setQuestionResponse = (optIdx: number, e: any) => {
    currentQuestion.responses.forEach((x, i) => {
      x.selected = i === optIdx;
      x.textResponse = i === optIdx ? String(e.target.value) : '';
    });
  };

  const handleMutuallyExclusiveResponse = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedId = Number(e.target.value);
    const optIdx = currentQuestion.responses.findIndex((x) => x.id === selectedId);

    if (optIdx !== -1) {
      setQuestionResponse(optIdx, e);
      setSelected(selectedId);
      triggerEligibility();
    }
  };

  const currentStepResponses = currentQuestion.responses;
  return (
    <>
      {currentStepResponses.some((opt) => opt.responseType === 'MutuallyExclusive') && (
        <RadioGroup sx={{ gap: 2, padding: 2 }} onChange={handleMutuallyExclusiveResponse} value={selected}>
          {currentQuestion.responses.map((opt) => {
            const key = `option-${opt.id}`;
            if (opt.responseType === 'MutuallyExclusive') {
              return (
                <Grid
                  size={{ xs: 12 }}
                  key={key}
                  flexWrap={'wrap'}
                  alignContent="center"
                  justifyContent={'flex-start'}
                  flexDirection={'row'}
                  display={'flex'}
                >
                  <FormControlLabel value={opt.id} control={<Radio />} label={opt.text} />
                </Grid>
              );
            }
            return null;
          })}
        </RadioGroup>
      )}
    </>
  );
};
